import { render, staticRenderFns } from "./XvOrders.vue?vue&type=template&id=6e0d5f56&"
import script from "./XvOrders.vue?vue&type=script&lang=ts&"
export * from "./XvOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports